// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"d38fb504","538":"ae2310de","545":"363a01e3","566":"b587720b","614":"084c75c7","676":"87eef8f1","882":"3c816a7d"}[chunkId] + ".chunk.js";
};